import Icon from '../../components/Icon.vue'

Icon.register({"regular/lightbulb":{"width":384,"height":512,"paths":[{"d":"M272 428V456C272 466.4 265.3 475.3 256 478.6V488C256 501.3 245.3 512 232 512H152C138.7 512 128 501.3 128 488V478.6C118.7 475.3 112 466.4 112 456V428C112 421.4 117.4 416 124 416H260C266.6 416 272 421.4 272 428zM128 176C128 140.7 156.7 112 192 112 200.8 112 208 104.8 208 96S200.8 80 192 80C139.1 80 96 123.1 96 176 96 184.8 103.2 192 112 192S128 184.8 128 176zM192 48C262.7 48 320 105.3 320 176 320 253.6 282.6 236.5 239 336H145C101.3 236.3 64 253.9 64 176 64 105.3 121.3 48 192 48M192 0C94.8 0 16 78.8 16 176 16 277.7 67.7 267.5 106.5 368.7 110.1 377.9 119 384 128.9 384H255.1C265 384 273.9 377.9 277.5 368.7 316.3 267.5 368 277.7 368 176 368 78.8 289.2 0 192 0z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/lightbulb.js
// module id = null
// module chunks = 